module.exports = __webpack_public_path__ + "img/forum-2016.e2b40374.jpg";